export const SENTRY = {
  DSN: 'https://6ffbdcb6d44f4645880ed365f1cc35ca@o1181940.ingest.sentry.io/6295711',
};
